import './Governance.css';

const PENDING_PROPOSALS = [
  {
    id: '1',
    actionType: 'app.polymessenger/device.link',
    description: 'Device: MacBook Pro (Desktop)',
    action: 'Link as new device',
    submitted: '5m ago',
    required: 1,
    current: 0,
  },
  {
    id: '2',
    actionType: 'app.polymessenger/guardian.accept',
    description: 'From: Alice (5Vss...N9Xo)',
    action: "Become Alice's recovery guardian",
    submitted: '2h ago',
    required: 1,
    current: 0,
  },
];

const THRESHOLDS = [
  { action: 'Device Link', threshold: '1/1', signers: 'You only' },
  { action: 'Device Revoke', threshold: '2/2', signers: 'You + existing device' },
  { action: 'Guardian Add', threshold: '2/2', signers: 'You + guardian' },
  { action: 'Account Recovery', threshold: '3/5', signers: 'Guardians' },
];

export default function Governance() {
  return (
    <div className="governance-page animate-in">
      {/* Header */}
      <div className="page-actions">
        <button className="btn btn-secondary">Audit Log →</button>
      </div>

      {/* Pending Approvals */}
      <section className="governance-section">
        <h2 className="section-title">
          Pending Approvals
          <span className="badge badge-warning">{PENDING_PROPOSALS.length}</span>
        </h2>
        
        <div className="proposals-list">
          {PENDING_PROPOSALS.map((proposal) => (
            <div key={proposal.id} className="proposal-card card">
              <div className="proposal-header">
                <span className="proposal-type">{proposal.actionType}</span>
                <span className="badge badge-warning">
                  ⏳ Awaiting {proposal.current}/{proposal.required}
                </span>
              </div>
              
              <div className="proposal-content">
                <div className="proposal-row">
                  <span className="proposal-label">Description:</span>
                  <span className="proposal-value">{proposal.description}</span>
                </div>
                <div className="proposal-row">
                  <span className="proposal-label">Action:</span>
                  <span className="proposal-value">{proposal.action}</span>
                </div>
                <div className="proposal-row">
                  <span className="proposal-label">Submitted:</span>
                  <span className="proposal-value">{proposal.submitted}</span>
                </div>
              </div>

              <div className="proposal-actions">
                <button className="btn btn-primary">Approve with Spark</button>
                <button className="btn btn-secondary">View Details</button>
                <button className="btn btn-danger">Reject</button>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Approval Thresholds */}
      <section className="governance-section">
        <h2 className="section-title">Approval Thresholds</h2>
        <div className="card">
          <table className="table">
            <thead>
              <tr>
                <th>Action</th>
                <th>Threshold</th>
                <th>Signers</th>
              </tr>
            </thead>
            <tbody>
              {THRESHOLDS.map((t, i) => (
                <tr key={i}>
                  <td>{t.action}</td>
                  <td>
                    <span className="threshold-badge">{t.threshold}</span>
                  </td>
                  <td>{t.signers}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>
    </div>
  );
}
